import { Vue, Component, Prop } from 'vue-property-decorator'
import { ConfigurationDeviceResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'
import ConfigurationInstrumentationDevicesModalVisibilityFormOperations
    from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-visibility-form-operations/configuration-instrumentation-devices-modal-visibility-form-operations.vue'
import ConfigurationInstrumentationDevicesModalVisibilityFormSectionAssay
    from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-visibility-form-section-assay/configuration-instrumentation-devices-modal-visibility-form-section-assay.vue'

@Component({
    components: {
        ConfigurationInstrumentationDevicesModalVisibilityFormOperations,
        ConfigurationInstrumentationDevicesModalVisibilityFormSectionAssay
    }
})
export default class ConfigurationInstrumentationDevicesModalVisibilityForm extends Vue {
    @Prop() readonly device!: ConfigurationDeviceResponse
}
